import React from 'react'
import { Link } from 'react-router-dom'
import { FiSidebar, FiMenu, FiSearch } from 'react-icons/fi'
import { useAuth } from 'context/auth'
import UserMenu from './user-menu'

const focusRing =
  'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ember focus-visible:tw-ring-offset-2'

const isMac =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent || '')

function TopBar({ expanded, onToggleRail, mobileOpen, onOpenMobile, onOpenPalette }) {
  const { currentUser } = useAuth()
  const headerImage = currentUser?.account?.branding?.topHeaderImage

  return (
    <div className='tw-flex tw-h-14 tw-min-w-0 tw-items-center tw-gap-3 tw-border-b tw-border-line tw-bg-canvas tw-px-5'>
      <button
        type='button'
        onClick={onToggleRail}
        aria-expanded={expanded}
        aria-label={expanded ? 'Collapse navigation' : 'Expand navigation'}
        className={`tw-hidden tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-[10px] tw-text-inkSoft hover:tw-bg-sand md:tw-inline-flex ${focusRing}`}
      >
        <FiSidebar aria-hidden='true' className='tw-h-5 tw-w-5' />
      </button>

      <button
        type='button'
        onClick={onOpenMobile}
        aria-expanded={mobileOpen}
        aria-label='Open navigation'
        className={`tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-[10px] tw-text-inkSoft hover:tw-bg-sand md:tw-hidden ${focusRing}`}
      >
        <FiMenu aria-hidden='true' className='tw-h-5 tw-w-5' />
      </button>
      <Link to='/' aria-label='LoyalIdeas home' className={`tw-shrink-0 tw-rounded-[10px] md:tw-hidden ${focusRing}`}>
        <img src='/img/logo.svg' alt='' className='tw-h-7 tw-w-auto' />
      </Link>

      {headerImage && (
        <img
          src={headerImage}
          alt={currentUser?.account?.organisationName || 'Brand logo'}
          className='tw-hidden tw-h-8 tw-max-w-[140px] tw-object-contain sm:tw-block'
        />
      )}

      <div className='tw-ml-auto tw-flex tw-min-w-0 tw-items-center tw-gap-3'>
        <button
          type='button'
          onClick={onOpenPalette}
          aria-label='Search'
          aria-keyshortcuts={isMac ? 'Meta+K' : 'Control+K'}
          className={`tw-inline-flex tw-h-9 tw-items-center tw-gap-2 tw-rounded-[10px] tw-border tw-border-line tw-bg-white tw-text-inkFaint hover:tw-bg-sand tw-w-9 tw-justify-center sm:tw-w-[140px] sm:tw-justify-start sm:tw-px-3 ${focusRing}`}
        >
          <FiSearch aria-hidden='true' className='tw-h-4 tw-w-4 tw-shrink-0' />
          <span className='tw-hidden tw-text-[14px] sm:tw-inline'>Search</span>
          <kbd className='tw-ml-auto tw-hidden tw-rounded tw-border tw-border-line tw-bg-sand tw-px-1.5 tw-font-sans tw-text-[11px] tw-text-inkSoft sm:tw-inline'>
            {isMac ? '⌘K' : 'Ctrl K'}
          </kbd>
        </button>
        <UserMenu />
      </div>
    </div>
  )
}

export default TopBar
